import { render, staticRenderFns } from "./SingleShipmentBox.vue?vue&type=template&id=edd32534&scoped=true&"
import script from "./SingleShipmentBox.vue?vue&type=script&lang=js&"
export * from "./SingleShipmentBox.vue?vue&type=script&lang=js&"
import style0 from "./SingleShipmentBox.vue?vue&type=style&index=0&id=edd32534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd32534",
  null
  
)

export default component.exports